module.exports = __webpack_public_path__ + "img/fangtan1-1.e89a5bb4.png";